import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 0 0 24px 0;
  padding: 17px 0 0 0;
`
